module.exports = __webpack_public_path__ + "img/avatar_boy.5829ed55.png";